export * from './index';



// WEBPACK FOOTER //
// ./~/angular2-font-awesome/angular2-font-awesome.ts